import {Dispatch, Fragment, SetStateAction, ClipboardEvent} from 'react';

import {times} from 'lodash';
import styled from 'styled-components';

import FormPieInput from '~/shared/components/FormField/FormInput/FormPieInput';

import useCreditCardNumberInput from './useCreditCardNumberInput';

const Root = styled.div`
  display: flex;
  direction: ltr;
  gap: 8px;
  align-items: center;
`;

const PieInput = styled(FormPieInput).attrs({
  removeFloatLabel: true,
})`
  direction: ltr;

  &&& input {
    text-align: center;
  }
`;

const Spacer = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 1px;
  background-color: ${({theme}) => theme.colors.contentDisabled};
`;

type PieCreditCardNumberInputProps = {
  className?: string;
  setSubmitError?: Dispatch<
    SetStateAction<{
      show: boolean;
      errorMsg: string;
    }>
  >;
  cardNumber: string[];
  setCardNumber: Dispatch<SetStateAction<string[]>>;
  cardInputError: boolean;
  setCardInputError: Dispatch<SetStateAction<boolean>>;
};

const PieCreditCardNumberInput = ({className, cardInputError, cardNumber, setCardInputError, setCardNumber, setSubmitError}: PieCreditCardNumberInputProps) => {
  const {handleInputChange} = useCreditCardNumberInput({cardNumber, setCardInputError, setSubmitError, setCardNumber});
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const digitsOnly = pastedData.replace(/\D/g, '');
    setCardNumber(Array.from({length: 4}, (_, i) => digitsOnly.slice(i * 4, (i * 4) + 4)));
  };

  return (
    <Root className={className}>
      {times(4, index => (
        <Fragment key={index}>
          <PieInput
            type="tel"
            hasError={cardInputError}
            id={index.toString()}
            onChange={handleInputChange}
            onPaste={handlePaste}
            value={cardNumber[index] ?? ''}
          />
          {index !== 3 && <Spacer />}
        </Fragment>
      ))}
    </Root>
  );
};

export default PieCreditCardNumberInput;
